import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row } from "react-bootstrap";
import "../../Auth/Registration/registration.css";
import { SET_RESET_REGISTRATION_STATE } from "../../../store/Registartion/types";
import { initialCallForRequiredData, initialCallForRequiredDataRoleSpecific } from "../../../store/Registartion/actions";
import EditPlantDetails from "./editPlantDetails";
import EditConsumerDetails from "./editConsumerDetails";
import EditCompanyDetails from "./editcompanyDetails";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";

const GnaRegistration = ({
 myProfileDetails,
 getMyProfileDetails,
 handleCloseEditProfileModal,
}) => {
 const dispatch = useDispatch();
 const [activeTab, setActiveTab] = useState(1);
 const [companyDetails, setCompanyDetails] = useState("");
 const [secDetails, setSecDetails] = useState("");
 const isRegistrationSucc = useSelector(
  (state) => state?.registrationReducer?.isRegistrationSucc
 );
 const role = useSelector((state) => state?.sessionState?.role);

 let userDetails = JSON.parse(localStorage.getItem("UserDetails"));
 let availableRoles =
  myProfileDetails?.userResponse?.userCompanies?.filter((item)=>item?.name !== "OTHER")?.[0]?.companyRoles?.map(
   (item) => item.role.role
  );
  let tab =
  availableRoles?.length === 2
  ? availableRoles?.filter((item) => item === "GENERATOR")?.length
  ? 1
  : 2
  : availableRoles?.length === 3
  ? 3
  : 4;
  console.log("availableRoles==>", {availableRoles,myProfileDetails,tab});
 const handleCompanyDetails = (data) => {
  setCompanyDetails(data);
  setActiveTab(2);
 };

 const handleSecDetails = (data) => {
  setSecDetails(data);
 };
 const handleStep2 = () => {
  if (activeTab === 1) {
   toast.info("Click on Save & Proceed Button for Step2", toastProperties);
  }
 };
 useEffect(() => {
    dispatch({ type: SET_RESET_REGISTRATION_STATE });
    initialCallForRequiredData({
     dispatch,
     reqData: tab == 1 ? "GENERATOR" : tab == 2 ? "CONSUMER" : "CONSUMER",
    });
    return () => {
     dispatch({ type: SET_RESET_REGISTRATION_STATE });
    };
   }, []);
  useEffect(()=>{
    if(activeTab !== 1){
  initialCallForRequiredDataRoleSpecific({reqData: tab == 1 ? 'GENERATOR' : tab == 2 ? 'CONSUMER' : activeTab === 2 ? 'GENERATOR' : activeTab === 3 ? 'CONSUMER' :'',dispatch })
    }
  },[activeTab])

 return (
  <>
   {role === "ANALYST" && (
    <Row>
     <div className="col-md-12">
      <div className="" style={{ borderRadius: "15px" }}>
       <div className="custom-tabs mt-3">
        <ul
         className="nav nav-pills justify-content-between mb-3"
         id="pills-tab"
         role="tablist"
        >
         <li className="nav-item" role="presentation">
          <button
           type="button"
           className={`nav-link ${activeTab === 1 ? "active" : ""}`}
           id="pills-home-tab"
           role="tab"
           aria-controls="pills-home"
           aria-selected="true"
           onClick={() => {
            activeTab != 1 && setActiveTab(1);
           }}
          >
           Company Details (Step 1)
          </button>
         </li>
         <li className="nav-item" role="presentation">
          <button
           className={`nav-link ${activeTab === 2 ? "active" : ""}`}
           id="pills-profile-tab"
           type="button"
           role="tab"
           aria-controls="pills-profile"
           aria-selected="false"
           onClick={handleStep2}
          >
           {tab == 1 
               ? "Plant Details (Step 2)"
               : tab == 2 ? "Consumer Details (Step 2)" 
               : "Plant & Consumer Details (Step 2)" }
          </button>
         </li>
        </ul>
        {/* tabs content */}
        <div className="tab-content p-4" id="pills-tabContent">
         {activeTab === 1 && (
          <div
           className="tab-pane fade show active"
           id="pills-home"
           role="tabpanel"
           aria-labelledby="pills-home-tab"
           tabIndex="0"
          >
           <EditCompanyDetails
            getMyProfileDetails={getMyProfileDetails}
            handleCompanyDetails={handleCompanyDetails}
            companyDetails={companyDetails}
            myProfileDetails={myProfileDetails}
            tab={tab}
           />
          </div>
         )}
         {activeTab === 2 && (
          <div
           className="tab-pane fade show active"
           id="pills-profile"
           role="tabpanel"
           aria-labelledby="pills-profile-tab"
           tabIndex="0"
          >
           {(tab == 1 || tab == 3 || tab==4 )&& (
            <EditPlantDetails
             handleCloseEditProfileModal={handleCloseEditProfileModal}
             getMyProfileDetails={getMyProfileDetails}
             myProfileDetails={myProfileDetails}
             companyDetails={companyDetails}
             secDetails={secDetails}
             handleSecDetails={handleSecDetails}
             tab={tab}
            />
           )}
           {tab == 2 && (
            <EditConsumerDetails
             handleCloseEditProfileModal={handleCloseEditProfileModal}
             getMyProfileDetails={getMyProfileDetails}
             myProfileDetails={myProfileDetails}
             companyDetails={companyDetails}
             secDetails={secDetails}
             handleSecDetails={handleSecDetails}
             tab={tab}
            />
           )}
          </div>
         )}
        </div>
       </div>
      </div>
     </div>
    </Row>
   )}
  </>
 );
};

export default GnaRegistration;
